
import { useEffect, useState } from "react"
import { BasicPage } from "../theme/Component/BasicPage"
import { PrintJson } from "../theme/Component/PrintJson";
import { DocumentStorageEditor } from "../contabilidad/bodegaDocumentos/DocumentStorageEditor";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { _BudgetID, _single } from "../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../theme/Component/BasicButton";
import useModal, { MODAL_XL } from "../theme/Component/hooks/useModal";
import { Modal } from "../theme/Component/Modal";
import { VisorDocumentFactory } from "../documents/VisorDocumentFactory";

interface Props {
    year?: number;
    mnemonic?: string;
    consecutive?: number;
}
export const BudgetReportCDP = ({ year, mnemonic, consecutive }: Props) => {

    const _budget = useDataBean(_BudgetID);
    const { lista, setLista, bean, setBean, instance } = _budget;
    const [document, setDocument] = useState<any>({});
    const [doc, setDoc] = useState<any>({});
    const modal = useModal("Documento", MODAL_XL);

    useEffect(() => {
        if (mnemonic && consecutive) {
            instance.getBudgetExecution(obtenerAnio(year), { Mnemonic: `=${mnemonic}`, Consecutive: consecutive }).then(
                (resp: any) => {
                    setLista(resp.filter(item => item.DataBeanProperties.Mnemonic == 'CDP'));
                }
            )
        }
    }, [mnemonic, consecutive])

    const getBudgetExecution = () => {
        instance.getBudgetExecution(obtenerAnio(document.DocumentDate), { Mnemonic: `=${document.Mnemonic}`, Consecutive: document.Consecutive }).then(
            (resp: any) => {
                setLista(resp.filter(item => item.DataBeanProperties.Mnemonic == 'CDP'));
            }
        )
    }
    const obtenerAnio = (fechaStr) => {
        if (!fechaStr) return null;
        return fechaStr.substring(0, 4);
    }
    const viewDocument = (mNemonic: string, consecutive: number) => {
        const temp = {
            mn: mNemonic,
            co: consecutive
        }
        setDoc(temp);
        modal.open();

    }


    const printCDP = (cdp) => {
        return (
            <div className="row">
                <div className="col">
                    <p>
                        <h6>Certificado Disponibilidad Presupuestal</h6>

                        <ul className="list-group">
                            <li className="list-group-item">
                                <div className="row">
                                    <div className="col-md-3">
                                        <strong className="link text-primary cursor" onClick={() => { viewDocument(cdp.Mnemonic, cdp.Consecutive) }}> {cdp.Mnemonic} - {cdp.Consecutive} </strong><br />
                                        {cdp.BudgetIDStr} - {cdp.BudgetName} <br />
                                        <strong>Tipo</strong> : - {cdp.NameTypeBudget} <br />
                                        <strong>Recurso</strong> : - {cdp.NameResource} <br />
                                        <strong>Fuente</strong> : - {cdp.NameSource} <br />
                                        <strong>Valor</strong>: {_single.formatMoney(cdp.CDPValue)}
                                        <hr />
                                        <strong>Saldo CDP</strong> : {_single.formatMoney(cdp.SaldoCDP)}
                                        <hr />
                                        <strong>Saldo RP</strong> : {_single.formatMoney(cdp.SaldoRP)}
                                    </div>
                                    <div className="col-md-9">
                                        {printRP(cdp.RPList)}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </p>
                </div>


            </div>
        )
    }
    const printRP = (lista) => {

        return (
            <p>
                <h6>Registros Presupuestal</h6>

                <ul className="list-group">
                    {lista.map((row) => {
                        return (
                            <li className="list-group-item">
                                <div className="row">
                                    <div className="col-md-3">
                                        <strong className="link text-primary cursor"
                                            onClick={() => { viewDocument(row.DataBeanProperties.Mnemonic, row.DataBeanProperties.Consecutive) }}>
                                            {row.DataBeanProperties.Mnemonic} - {row.DataBeanProperties.Consecutive} </strong>
                                        <br />
                                        {/* {row.DataBeanProperties.BudgetIDStr} <br /> */}
                                        <strong>
                                            {_single.formatMoney(row.DataBeanProperties.Value)}
                                        </strong>

                                    </div>
                                    <div className="col-md-9">
                                        <h6>Obligación Presupuestal</h6>
                                        {printOB(row.DataBeanProperties.OBList)}
                                    </div>
                                </div>
                            </li>
                        )
                    })}
                </ul>
            </p>
        )
    }
    const printOB = (lista) => {

        return (

            <ul className="list-group">
                {lista.map((row) => {
                    return (
                        <li className="list-group-item">
                            <div className="row">
                                <div className="col-md-3">
                                    <strong className="link text-primary cursor"
                                        onClick={() => { viewDocument(row.DataBeanProperties.Mnemonic, row.DataBeanProperties.Consecutive) }}>
                                        {row.DataBeanProperties.Mnemonic} - {row.DataBeanProperties.Consecutive} </strong>
                                    <br />

                                    <strong>
                                        {_single.formatMoney(row.DataBeanProperties.Value)}
                                    </strong>
                                </div>
                                <div className="col-md-9">
                                    <h6>Causacion / Egreso</h6>
                                    {printCE(row.DataBeanProperties.CEList)}
                                </div>
                            </div>
                        </li>
                    )
                })}
            </ul>

        )
    }
    const printCE = (lista) => {

        return (

            <ul className="list-group">
                {lista.map((row) => {
                    return (
                        <li className="list-group-item">
                            {/* <PrintJson json={row.DataBeanProperties}/> */}
                            <p>

                                {row.DataBeanProperties.DocumentMnemonic ? <strong className="link text-primary cursor"
                                    onClick={() => { viewDocument(row.DataBeanProperties.DocumentMnemonic, row.DataBeanProperties.DocumentConsecutive) }}>
                                    {row.DataBeanProperties.DocumentMnemonic} - {row.DataBeanProperties.DocumentConsecutive} </strong>
                                    :
                                    <span className="text-danger"> Pendiente</span>} /

                                {row.DataBeanProperties.CEMnemonic ?
                                    <strong className="link text-primary cursor"
                                        onClick={() => { viewDocument(row.DataBeanProperties.CEMnemonic, row.DataBeanProperties.CEConsecutive) }}>
                                        {row.DataBeanProperties.CEMnemonic} - {row.DataBeanProperties.CEConsecutive} </strong>
                                    :
                                    <span className="text-danger"> Pago Pendiente</span>}

                            </p>
                            <strong>
                                {_single.formatMoney(row.DataBeanProperties.Value)}
                            </strong>
                        </li>
                    )
                })}
                {lista.length == 0 &&
                    <p className="text-danger">Pendiente</p>
                }
            </ul>

        )
    }

    const print = () => {
        return (
            <div className="row">


                <div className="col-md-12 mt-4">
                    {lista.map((item: any) => {
                        return (
                            <>
                                {printCDP(item.DataBeanProperties)}
                            </>
                        )
                    })}
                    {/* <PrintJson json={lista} /> */}
                </div>
            </div>
        )
    }
    return (
        <BasicPage titulo="Ejecucion presupuestal CDP">
            {mnemonic ?
                <>
                    <div className="row">

                        <div className="col-md-12">
                            {print()}
                        </div>
                        <div className="col-md-12">
                            <Modal modal={modal.modal} updateModal={modal.setModal}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <VisorDocumentFactory Mnemonic={doc.mn} Consecutive={doc.co} />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </div>
                </>
                :
                <>
                    <div className="row">
                        <div className="col-md-3">
                            <DocumentStorageEditor label="Documento" onChange={(e) => { setDocument(e) }} />
                        </div>
                        <div className="col-md-4 mt-4">
                            <BasicButton disable={!document.IDDocument} icon="" eventClick={getBudgetExecution}>Consultar</BasicButton>
                        </div>
                        <div className="col-md-12">
                            {print()}

                        </div>
                        <div className="col-md-12">
                            <Modal modal={modal.modal} updateModal={modal.setModal}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <VisorDocumentFactory Mnemonic={doc.mn} Consecutive={doc.co} />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </div>
                </>
            }
        </BasicPage>
    )
}